import { Star } from "lucide-react";

import { cn } from "@/lib/utils";

interface FavoriteButtonProps {
  isFavorited?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  size?: "sm" | "md";
}

export function FavoriteButton({
  isFavorited = false,
  onClick,
  disabled = false,
  className,
  size = "sm",
}: FavoriteButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        // Base styles
        "group/fav relative inline-flex shrink-0 items-center justify-center",
        "rounded-md transition-all duration-200",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "disabled:pointer-events-none disabled:opacity-50",

        // Size variants
        size === "sm" && "size-7",
        size === "md" && "size-8",

        // Interactive background
        "hover:bg-accent active:scale-95",

        className
      )}
      aria-label={isFavorited ? "Remove from favorites" : "Add to favorites"}
      aria-pressed={isFavorited}
    >
      <Star
        className={cn(
          // Base icon styles
          "transition-all duration-200 ease-out",
          size === "sm" && "size-4",
          size === "md" && "size-[18px]",

          // State-based styling
          isFavorited
            ? "fill-amber-500 text-amber-500 drop-shadow-[0_0_3px_rgba(245,158,11,0.4)]"
            : "text-muted-foreground/70 group-hover/fav:text-muted-foreground",

          // Hover animation for unfavorited
          !isFavorited && "group-hover/fav:scale-110"
        )}
      />
    </button>
  );
}
